import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./slider.css"
const TopDevelopers = ({ topDevelopersData }) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1, // Added this line for consistency
    autoplay: true, // Enables auto-scrolling
    autoplaySpeed: 3000, // Auto-scroll interval in milliseconds (3 seconds)
    centerMode: true,
    arrows: false,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true, // Auto-scrolling for responsive view
          autoplaySpeed: 3000,
          centerMode: true,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true, // Auto-scrolling for responsive view
          autoplaySpeed: 3000,
          centerMode: true,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true, // Auto-scrolling for responsive view
          autoplaySpeed: 3000,
          centerMode: false,
        },
      },
    ],
  };

  const data = topDevelopersData.data;
  const Shape1=topDevelopersData.Shape1;
  const Shape2 = topDevelopersData.Shape2;
  return (
    <>
      <section className="brand-one">
        <div className=" mt-14">
          <div className="brand-one__shape-1 float-bob-y">
            {/* <img src={Shape2} alt="Sobha" /> */}
          </div>

          <div className="section-title text-left">
            <h2 className="section-title__title flex justify-center text-center mb-2 -mt-6">{topDevelopersData.title}</h2>
          </div>
          <div className="brand-one__shape-2 float-bob-x">
            {/* <img src={Shape2} alt="" /> */}
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="brand-one__inner">
                  <div
                    className="thm-swiper__slider swiper-container mt-[-12%] md:mt-[-3%]"
                   
                  >
                    <div>
                      <Slider {...settings}>
                        {
                          data.map((data, index) => (
                            <a href={data.link }
                            target="_blank">
                              <img index={index} src={data.image} alt="" className="w-[120px]   " />
                            </a>
                          ))
                        }
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TopDevelopers;
